import React, { useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { FiTrendingUp } from 'react-icons/fi';
import { useRetentionMetrics } from '@/hooks/useRetentionMetrics';
import { RetentionMetricsTabs } from './retention-metrics-tabs';
import { RetentionTaxonomyCard } from './retention-taxonomy-card';
import { Loader } from '@/components/custom/loader';
import './retention-metrics-dialog.sass';

export function RetentionMetricsDialog({ open, onClose }) {
  const { data, period, isLoading, error, expandedTaxonomy, fetchMetrics, changePeriod, toggleExpanded } = useRetentionMetrics();

  useEffect(() => {
    if (open) {
      fetchMetrics(period);
    }
  }, [open]);

  const handleOpenChange = isOpen => {
    if (!isOpen) {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onOpenChange={handleOpenChange}
    >
      <DialogContent className="retention-dialog">
        <DialogHeader className="retention-dialog__header">
          <div className="retention-dialog__title-wrapper">
            <FiTrendingUp className="retention-dialog__icon" />
            <DialogTitle className="retention-dialog__title">Sua Evolução</DialogTitle>
          </div>
        </DialogHeader>

        <RetentionMetricsTabs
          value={period}
          onChange={changePeriod}
        />

        <div className="retention-dialog__content">
          {isLoading ? (
            <div className="retention-dialog__loading">
              <Loader />
            </div>
          ) : error ? (
            <div className="retention-dialog__error">
              <p className="mb-4">Erro ao carregar métricas</p>
              <button onClick={() => fetchMetrics(period)}>Tentar novamente</button>
            </div>
          ) : data?.taxonomies?.length === 0 ? (
            <div className="retention-dialog__empty">
              <p className="mb-4">Você ainda não tem métricas de retenção.</p>
              <p className="mb-4">Continue estudando para ver sua evolução!</p>
            </div>
          ) : (
            <div className="retention-dialog__list">
              {data?.taxonomies?.map(taxonomy => (
                <RetentionTaxonomyCard
                  key={taxonomy.taxonomy_id}
                  taxonomy={taxonomy}
                  expanded={expandedTaxonomy === taxonomy.taxonomy_id}
                  onToggle={() => toggleExpanded(taxonomy.taxonomy_id)}
                />
              ))}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
